import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: theme.zIndex.drawer + 100,
    boxShadow: 'none',
    backgroundColor: '#e2e5e9',
    alignSelf: 'flex-end',
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    height: 40,
    textAlign: 'center',
    padding: '10px 0',
  }
}));

function Footer() {
  const classes = useStyles();
  return (
    <footer className={classes.root}>
      <div className={classes.footerText}>
        <p>
          <span>The information contained herein is </span>
          <span>confidential and property of Tenet Equity Advisors</span>
          <span>, LLC with all right resarved.</span>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
